/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-shared-pages-router',
    template: '<router-outlet></router-outlet>',
})
export class PagesSystemRouterComponent { }
